import request from '@/utils/request'

// 欠款列表
export const credit_list=(data)=>{
  return request({
    url: '/erp/order-credit/debts-list',
    method: 'get',
    data
  })
}

// 欠款买家的订单列表
export const credit_order_list=(data)=>{
  return request({
    url: '/erp/order-credit/order-credit-buyer-debts',
    method: 'get',
    data
  })
}

// 根据客户还款
export const credit_payment_buyer=(data)=>{
  return request({
    url: '/erp/order-credit/repayment-buyer',
    method: 'post',
    data
  })
}

// 根据订单
export const credit_payment_order=(data)=>{
  return request({
    url: '/erp/order-credit/repayment-order',
    method: 'post',
    data
  })
}


// 订单补录
export const credit_create=(data)=>{
  return request({
    url: '/erp/order-credit/edit-history',
    method: 'post',
    data
  })
}

// 订单pos支付
export const repayment_pay_pos=(data)=>{
  return request({
    url: '/erp/order-credit/repayment-pay',
    method: 'post',
    data
  })
}

// 订单查询 
export const repayment_check_pos=(data)=>{
  return request({
    url: '/erp/order-credit/repayment-query',
    method: 'post',
    data
  })
}